import React, { useContext, useState } from "react";
import { useMutation } from "@tanstack/react-query";

//App
import { LookupGroupFormContainerProps } from "../../../../types/lookupGroup";
import { SnackbarState } from "../../../../types";
import { LookupGroupDto } from "../../../../app/model/api/types/dto";
import lookupGroupApi from "../../../../app/model/api/lookupGroupApi";
import { apiErrorMessage } from "../../../../utility/lib/error";
import { LookupGroupViewModel } from "../../../../viewModels";
import { LookupGroupContext } from "./LookupGroupContainer";
import { EMPTY_GUID } from "../../../../utility/constants";
import LookupGroupForm from "./LookupGroupForm";

//Common
import Snackbar from "../../../common/VFX-UI/SnackBar/Snackbar";

export const LookupGroupFormContainer: React.FC<
  LookupGroupFormContainerProps
> = (props) => {
  const { onClose, onShowSuccess } = props;
  const lookupGroupContext = useContext(LookupGroupContext);

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = lookupGroupContext?.id
    ? "Lookup Group updated"
    : "New Group added";

  const onShowErrorSnackbar = (errorMessage: string) =>
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });

  const onCloseSnackbar = () =>
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });

  const { status, mutate } = useMutation<void, Error, LookupGroupDto>({
    mutationFn: async (payload: LookupGroupDto) => {
      const response = await lookupGroupApi.save(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
  });

  const handleOnSubmit = async (values: LookupGroupViewModel) => {
    const county: LookupGroupDto = values.toDto();
    mutate(county);
  };

  let lookupTypeId =
    lookupGroupContext?.lookupTypeId !== null &&
    lookupGroupContext?.lookupTypeId !== undefined
      ? [lookupGroupContext.lookupTypeId]
      : [];

  const initialValues = lookupGroupContext?.id
    ? new LookupGroupViewModel(
        lookupGroupContext.data?.id ?? null,
        lookupGroupContext.data?.name ?? null,
        lookupGroupContext.data?.description ?? null,
        lookupGroupContext.data?.typeId !== null &&
        lookupGroupContext.data?.typeId !== undefined
          ? [lookupGroupContext.data?.typeId]
          : null,
        lookupGroupContext.data?.sortValue ?? null,
        lookupGroupContext.data?.isActive ?? null
      )
    : new LookupGroupViewModel(EMPTY_GUID, "", "", lookupTypeId, 100, true);

  return (
    <>
      <LookupGroupForm
        initialVal={initialValues}
        status={status}
        handleOnSubmit={handleOnSubmit}
        onClose={onClose}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
};
